import { TrackableDefinitions } from 'automation-ui-usage-tracking/Trackables';
import TrackingEvents from 'automation-ui-usage-tracking/TrackingEvents';
import { parseLocation } from 'automation-ui-routing/utils';
const APP_PATH_REGEX = /\/flow\/([0-9]+)/;
const EMBED_ACTION_SIDEPANEL_PATH_REGEX = /\/embedded\/embedded-configs\/([0-9]+)/;
export const parseFlowIdFromLocation = () => {
  const {
    href
  } = window.location;
  const appMatches = href.match(APP_PATH_REGEX);
  const embedActionSidepanelMatches = href.match(EMBED_ACTION_SIDEPANEL_PATH_REGEX);
  let flowId;
  if (appMatches) {
    flowId = appMatches[1];
  } else if (embedActionSidepanelMatches) {
    flowId = embedActionSidepanelMatches[1];
  } else {
    const {
      activeFlowId
    } = parseLocation(window.location);
    flowId = activeFlowId;
  }
  return flowId ? Number(flowId) : undefined;
};
export let trackPageView = (usageTracker, screenData, extraJSON) => {
  if (usageTracker) {
    const flowId = parseFlowIdFromLocation();
    const trackingData = Object.assign({}, extraJSON, screenData);
    if (flowId) {
      trackingData.flowId = flowId;
    }
    usageTracker.track(TrackingEvents.PAGE_VIEW, trackingData);
  }
};
export const trackSubscreenView = (usageTracker, screenData, extraJSON) => {
  if (usageTracker) {
    const flowId = parseFlowIdFromLocation();
    usageTracker.track(TrackingEvents.SUBSCREEN_VIEW, Object.assign({}, extraJSON, screenData, {
      flowId
    }));
  }
};
export let trackEvent = (usageTracker, trackableKey, extraJSON) => {
  if (usageTracker && trackableKey && TrackableDefinitions.has(trackableKey)) {
    const trackDefFactory = TrackableDefinitions.get(trackableKey);
    const flowId = parseFlowIdFromLocation();
    const trackingData = Object.assign({}, extraJSON);
    if (flowId) {
      trackingData.flowId = flowId;
    }
    const trackDef = trackDefFactory(trackingData);
    usageTracker.track(trackDef.eventType, trackDef.eventProps);
  }
};
export const trackedEventPartial = (usageTracker, trackableKey, extraJSON) => {
  return onEvent => {
    trackEvent(usageTracker, trackableKey, extraJSON);
    if (onEvent) {
      onEvent();
    }
  };
};

// dev note - this is the recommended pattern to avoid spying on properties of namespace imports:
// https://product.hubteam.com/docs/frontend/kb/concatenated-spies.html
export const trackingUtilSettersForTesting = {
  setTrackEventForTesting: func => {
    trackEvent = func;
  },
  setTrackPageViewForTesting: func => {
    trackPageView = func;
  }
};